import Error from '../model/Error';
import Section from '../dto/Section';
import axios from 'axios';

export default class SectionRepository {
    static create(federationId, name) {
        return new Promise((resolve, reject) => {
            axios
                .post('/sections', { federationId, name })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(sectionId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/sections/${sectionId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(sections) {
        return Promise.all(sections.map((section) => {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/sections/${section.id}`, { name: section.name })
                    .then(() => resolve())
                    .catch((error) => reject(Error.fromResponse(error.response)));
            });
        }));
    }

    static findAll(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/sections`)
                .then((response) => resolve(response.data.data.map((data) => Section.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
